import { render, staticRenderFns } from "./Blank.vue?vue&type=template&id=7ba8049d&scoped=true&"
var script = {}
import style0 from "./Blank.vue?vue&type=style&index=0&id=7ba8049d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ba8049d",
  null
  
)

export default component.exports